import type { McqOption } from '../../../../types/mcq';
import {
  applyChoiceRandomization,
  type ChoiceRandomizationConfig,
} from '../shared/choiceRandomization';

/** Randomize regular MCQ options only; Other options stay last in original order. */
export function applyMcqChoiceRandomization(
  options: McqOption[],
  randomization: ChoiceRandomizationConfig | undefined,
  defaultOptionIds?: string[]
): { options: McqOption[]; shuffleOptions: boolean } {
  const otherOptions = options.filter(option => option.otherOption);
  const regularOptions = options.filter(option => !option.otherOption);

  const regularDefaultIds = defaultOptionIds?.filter(id =>
    regularOptions.some(option => option.id === id)
  );

  const { options: randomizedRegular, shuffleOptions } = applyChoiceRandomization(
    regularOptions,
    randomization,
    regularDefaultIds
  );

  return {
    options: [...randomizedRegular, ...otherOptions],
    shuffleOptions,
  };
}
